<template>
    <b-card class="post" no-body>
        <template #header>
            <h6 class="mb-0">{{ title }}</h6>
        </template>
        <b-list-group flush v-if="!busy">
            <span v-if="posts != null && posts.length > 0">
                <home-post-item v-for="(item,index) in posts" :model="item" :key="index" :index="index" />
            </span>
            <app-no-data-image v-else width="100%" imgSrc="no-post.png" />
        </b-list-group>
        <b-list-group flush v-else>
            <b-list-group-item>
                <b-skeleton width="85%" class="mb-1"></b-skeleton>
            </b-list-group-item>
            <b-list-group-item>
                <b-skeleton width="85%" class="mb-1"></b-skeleton>
            </b-list-group-item>
            <b-list-group-item>
                <b-skeleton width="85%" class="mb-1"></b-skeleton>
            </b-list-group-item>
        </b-list-group>
    </b-card>
</template>
<script>
import HomePostItem from './HomePostItem.vue';

export default {
    components: {HomePostItem},
    props: {
        title : {
            type: String,
            default: '-',
        },
        posts: {
            type: Array,
            default: [],
        },
        busy : {
            type: Boolean,
            default: false
        }
    }
}
</script>